import { queryOptions, useMutation } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { CreatePollRequest, CreatePostRequest, Unit } from '@/api/pending'
import { queryKeys } from '@/api/queryKeys'

export const unitsQuery = (condoId: number) =>
  queryOptions({
    queryKey: queryKeys.units(condoId),
    queryFn: ({ signal }) =>
      api
        .get<Unit[]>('/condominiums/:id/units', {
          params: { id: condoId },
          query: { include: 'residents' },
          signal,
        })
        .then((d) => d ?? []),
  })

export function useCreatePost(condoId: number) {
  return useMutation({
    mutationFn: (req: CreatePostRequest) =>
      api.post('/condominiums/:id/posts', req, { params: { id: condoId } }),
  })
}

export function useCreatePoll(condoId: number) {
  return useMutation({
    mutationFn: (req: CreatePollRequest) =>
      api.post('/condominiums/:id/polls', req, { params: { id: condoId } }),
  })
}
